
function afterEach(to, from) {

}

export default afterEach

